import { createSlice } from "@reduxjs/toolkit";

const sortByDateFn = (a, b) => (new Date(b.expire_date) - new Date(a.expire_date))

export const completedOperationsSlice = createSlice({
    name: 'completedOperations',
    initialState: [],
    reducers: {
        empty: state => {
            return []
        },
        setCompletedOperations: (state, action) => {
            if (Array.isArray(action?.payload)) {
                const sorted = action?.payload?.sort(sortByDateFn);
                return sorted
            }
        },
        addCompletedOp: (state, action) => {
            const existingIndex = state.findIndex((op) => op.id === Number(action.payload?.id));
          
            let updatedState;
          
            if (existingIndex !== -1) {
              // Replace the existing item with the updated one
              updatedState = [...state];
              updatedState[existingIndex] = {
                ...updatedState[existingIndex],
                ...action.payload,
              };
            } else {
              // Add the new item
              updatedState = [...state, action.payload];
            }
            // console.log('updatedState.sort(sortByDateFn);', updatedState)

            // Sort and return
            return updatedState.sort(sortByDateFn);
        },          
        updateCompletedOp: (state, action) => {
            const foundedIndex = state.findIndex((op) => op.id === action.payload?.id);
            if (foundedIndex !== -1) {
                // Directly mutate the state at the found index
                state[foundedIndex] = { ...state[foundedIndex], ...action.payload };
                return state; // This ensures the updated state is returned
            } else {
                throw new Error('Operation not found');
            }
        },
        removeCompletedOp: (state, action) => {
            return state.filter(operation => Number(operation.id) !== Number(action.payload?.id));
            
            // const foundedIndex = state.findIndex((operation) => operation.id === action.payload?.id);
            // if (foundedIndex) {
            //     return state.splice(foundedIndex, 1)
            // }
            // return state
            return []
        }
    }
});

export const {
    empty, 
    setCompletedOperations,
    updateCompletedOp,
    addCompletedOp,
    removeCompletedOp,
} = completedOperationsSlice.actions;

export default completedOperationsSlice.reducer;